<template>
	<div class="page">
		<div class="header">
			<div style="float: left; line-height: 58px;">
				客服留言
			</div>

			<div style="margin-left: 80px; line-height: 12px; padding-top: 5px;">
				<div  style="font-size: 12px; padding-top: 3px;" v-if="ywywx">专享客服微信：{{ywywx?ywywx:'暂无专享客服'}}</div>
				<div  style="font-size: 12px; padding-top: 3px;" v-if="ywyphone">专享客服电话：{{ywyphone?ywyphone:'暂无专享客服电话'}}</div>
				<div style="font-size: 12px; padding-top: 3px;">
					<a href="tel:4009217922">过敏宝宝网专享客服：4009217922</a>
				</div>
				<div style="font-size: 12px; padding-top: 3px;">
					专享客服微信：fanchen-sansheng
				</div>
				
				<div style="font-size: 12px; padding-top: 3px;">
					<a href="tel:18017126416">过敏宝宝网营养顾问耿老师：18017126416</a>
				</div>
			</div>
		</div>
		<div :class="['msgbox',ywywx?'msgboxbig':'']" id="msgbox">

			<div v-for="item of msgList" style="padding: 10px;">
				<div v-if="item.touid==userInfo.uid">
					<div style="height: 50px; width: 50px; float: left;">

						<img src="http://file.modubus.com/otherpros/ot/kefu.jpg" style="width: 100%; height: 100%;border-radius: 4px;" />

					</div>

					<div style="min-height: 50px; margin-left: 70px; ">

						<div style="color: #000; background: #007AFF; color: #fff; border-radius: 4px; display: inline-block; padding: 15px;position: relative;">
							<div style="position: absolute; width: 20px; height: 20px;left:-12px; top: 5px; color: #007AFF;">
								<svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
								 viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2016">
									<path d="M769.81 12.469l-624.414 499.531 624.414 499.531z" p-id="2017"></path>
								</svg>
							</div>
							<span v-if="item.msgtype=='text'">{{item.msg}}</span>
							<span v-if="item.msgtype=='image'" style="width: 100px; display: inline-block;">
								<img @click="viewBig(item.msg)" :src="item.msg" style="width: 100%; vertical-align: middle;" />
							</span>
						</div>
					</div>
				</div>


				<div v-else>
					<div style="height: 50px; width: 50px; float: right;">
						<img :src="userInfo.headimgurl" style="width: 100%; height: 100%;border-radius: 4px;" />
					</div>

					<div style="min-height: 50px; margin-right: 70px;text-align: right;">

						<div style="color: #000; background: #007AFF; color: #fff; border-radius: 4px; display: inline-block; padding: 15px;position: relative;">
							<div style="position: absolute; width: 20px; height: 20px;right:-12px; top: 5px; color: #007AFF;">
								<svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
								 viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2327">
									<path d="M210.94399999999996 0L813.056 512.0000000000001 210.94399999999985 1024Z" p-id="2328"></path>
								</svg>
							</div>
							<span v-if="item.msgtype=='text'">{{item.msg}}</span>
							<span v-if="item.msgtype=='image'" style="width: 100px; display: inline-block;">
								<img @click="viewBig(item.msg)" :src="item.msg" style="width: 100%; vertical-align: middle;" />
							</span>
						</div>
					</div>
				</div>

			</div>


		</div>
		<div class="inputbox">
			<div class="btntel flexcenter">
				<svg class="icon" style="width: 30px; height: 30px;vertical-align: middle;fill: #26a1ff;overflow: hidden;" viewBox="0 0 1024 1024"
				 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1473">
					<path d="M605.323264 83.209216c-2.212864-0.467968-4.405248-0.723968-6.598656-0.8192-19.753984-0.755712-37.037056 12.750848-41.017344 32.152576-2.194432 10.52672-0.149504 21.286912 5.787648 30.301184 5.917696 9.004032 14.98624 15.156224 25.5232 17.3056 84.826112 17.508352 157.858816 67.093504 205.625344 139.616256 47.745024 72.554496 64.391168 159.220736 46.936064 244.045824-2.193408 10.559488-0.149504 21.298176 5.788672 30.290944 5.917696 9.004032 14.98624 15.14496 25.5232 17.327104 2.212864 0.436224 4.44928 0.703488 6.62016 0.80896 8.451072 0.319488 16.623616-1.980416 23.692288-6.62016 9.003008-5.927936 15.1552-15.00672 17.32608-25.53344C965.613568 343.166976 824.231936 128.325632 605.323264 83.209216L605.323264 83.209216zM674.717696 688.673792c2.382848 1.554432 55.5776 35.707904 96.448512 77.683712 15.388672 15.879168 41.166848 42.4448 40.484864 73.2672-0.574464 21.052416-12.45184 42.16832-36.334592 64.454656-5.9392 5.83168-59.133952 55.515136-144.234496 55.515136-23.309312 0-47.255552-3.703808-71.181312-10.985472-25.1392-7.619584-50.704384-19.392512-75.907072-34.929664-99.51232-58.771456-176.313344-134.444032-249.239552-245.440512-125.353984-190.768128-128.95232-354.1504-128.376832-384.941056 0.212992-142.1056 118.564864-198.003712 132.059136-203.921408 18.562048-8.609792 34.782208-12.750848 49.724416-12.750848 7.15264 0 14.007296 0.968704 20.349952 2.906112 13.047808 3.958784 31.163392 14.21824 43.338752 40.592384 16.603136 35.781632 32.313344 87.081984 43.040768 140.786688 11.282432 55.738368-19.966976 71.38304-50.192384 86.50752l-1.19296 0.521216c0 0-53.471232 22.308864-62.87872 26.182656-9.238528 3.852288-14.04928 14.261248-10.899456 23.776256 21.563392 65.327104 54.493184 133.070848 95.192064 195.90656 40.039424 61.827072 87.656448 118.884352 137.678848 165.074944 3.575808 3.257344 8.173568 5.087232 13.028352 5.087232l1.639424-0.084992c5.257216-0.42496 10.217472-3.086336 13.5168-7.3216 8.129536-10.450944 20.603904-25.511936 33.759232-38.038528 24.946688-23.723008 47.509504-35.238912 68.967424-35.238912 5.874688 0 11.708416 0.862208 17.327104 2.576384C656.219136 677.510144 664.925184 682.192896 674.717696 688.673792L674.717696 688.673792zM505.449472 413.687808c-10.558464-2.192384-19.627008-8.323072-25.54368-17.31584-5.960704-9.004032-8.003584-19.775488-5.832704-30.332928 4.0448-19.381248 21.285888-32.898048 41.018368-32.110592 2.193408 0.064512 4.407296 0.329728 6.619136 0.787456 93.553664 19.286016 153.986048 111.135744 134.720512 204.732416-2.1504 10.492928-8.280064 19.550208-17.284096 25.521152-7.088128 4.629504-15.30368 6.918144-23.691264 6.62016-2.171904-0.115712-4.385792-0.362496-6.598656-0.830464-10.579968-2.139136-19.667968-8.312832-25.585664-17.327104-5.917696-8.972288-7.9616-19.710976-5.789696-30.268416 4.980736-24.223744 0.256-48.958464-13.411328-69.669888C550.448128 432.82432 529.650688 418.669568 505.449472 413.687808L505.449472 413.687808zM547.340288 287.418368c-21.75488-4.512768-35.80416-25.851904-31.3344-47.596544 4.001792-19.423232 21.243904-32.951296 40.997888-32.18432 2.169856 0.095232 4.406272 0.351232 6.619136 0.8192 75.71456 15.612928 140.852224 59.845632 183.510016 124.608512 42.59328 64.720896 57.470976 142.063616 41.847808 217.7792-2.171904 10.558464-8.324096 19.647488-17.328128 25.53344-7.087104 4.672512-15.240192 6.960128-23.668736 6.6304-2.194432-0.096256-4.427776-0.362496-6.641664-0.830464-21.711872-4.458496-35.781632-25.808896-31.311872-47.59552 11.260928-54.6304 0.53248-110.485504-30.247936-157.241344C649.003008 330.60864 602.003456 298.669056 547.340288 287.418368z"
					 p-id="1474"></path>
				</svg>
			</div>
			<div class="inputbar">
				<input type="text" v-model="word" />
			</div>

			<div class="sendbtn flexcenter" @click="Send">发送</div>
			<div class="imagebtn flexcenter" @click="chooseImage"></div>
		</div>
		<div style="display: none;">
			<input type="file" id="upfile" @change="uploadImage" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				msgList: [],
				userInfo: {
					headimgurl: "",
					nickname: "",
					uid: 0
				},
				ywywx:"",
				word: "",
				ywyphone:""
			}
		},
		beforeMount() {

			this.$store.dispatch("DECODEINFO", {}).then(data => {
				this.userInfo = data
				console.log(this.userInfo)
				this.getList();
				this.getMyInfo();
			})

		},
		methods: {
			getMyInfo() {
				this.$store.dispatch("GET", {
					url: "/api/wx/?action=me"
				}).then(result => {
					this.ywywx = result.data.data.rows[0].ywywechat;
					this.ywyphone = result.data.data.rows[0].ywyphone;
				})
			},
			getList(refresh) {
				if (refresh) {
					this.msgList = [];
				}
				this.$store.dispatch("GET", {
					url: "/api/chat/?action=cusdetail&rows=50&pageidx=1"
				}).then(result => {
					this.msgList = result.data.rows.rows.reverse()
					for (let item of this.msgList) {
						item.msg = decodeURIComponent(item.msg)
					}
					//如果有新消息，则滚到最下方
					this.$nextTick(() => {
						$("#msgbox").scrollTop(99999)
					})

					setTimeout(() => {
						this.getList();
					}, 8000)
				})
			},
			Send() {
				this.$store.dispatch("POST", {
					url: "/api/chat/?action=chatwith",
					query: {

						type: "text",
						msg: encodeURIComponent(this.word),
						uid: "0",
					}
				}).then(result => {
					this.getList();
					this.word = "";
				})
			},
			chooseImage() {
				document.getElementById("upfile").click();

			},
			uploadImage() {
				let file = document.getElementById("upfile").files[0];
				let fileObj = {
					file: file,
					onSuccess: (res) => {
						this.$store.dispatch("POST", {
							url: "/api/chat/?action=chatwith",
							query: {

								type: "image",
								msg: encodeURIComponent(res.src),
								uid: "0",
							}
						}).then(result => {
							this.getList();

						})
					}
				}
				this.uploadOss(fileObj)
			},
			viewBig(item) {
				console.log(item)
				window.open(item, "_blank")
			}
		}
	}
</script>

<style scoped="scoped">
	.page {
		height: 100%;
		width: 100%;
		position: relative;
		opacity: 1;
	}

	.header {
		width: 94%;
		min-height: 58px;
		background: -webkit-gradient(linear, left top, right bottom, color-stop(0%, #9dc3fb), color-stop(100%, #84b2f7));
		position: absolute;
		top: 0;
		line-height: 40px;
		color: #fff;
		padding: 0 3%;
		padding-bottom: 5px;
		z-index: 10;
	}

	.inputbox {
		height: 54px;
		background: #f6fafe;
		width: 100%;
		position: absolute;
		bottom: 0;
	}

	.btntel {
		height: 100%;
		width: 14%;
		float: left;
	}

	.inputbar {
		height: 40px;
		width: 55%;
		padding: 7px 0;
		float: left;
	}

	.inputbar>input {
		border: 0;
		background: #e9edf5;
		height: 100%;
		width: 94%;
		padding: 0 3%;
		border-radius: 4px;
	}

	.sendbtn {
		height: 40px;
		width: 15%;
		background: #26a1ff;
		float: right;
		color: #fff;
		margin-top: 7px;
		margin-right: 7px;
		border-radius: 4px;
	}

	.sendbtn:active {
		background: #167ece;
	}

	.imagebtn {
		height: 40px;
		width: 10%;
		background: #43AEFF;
		float: right;
		color: #fff;
		margin-top: 7px;
		margin-right: 7px;
		border-radius: 4px;
		background-image: url(../../public/static/images/add.png);
		background-size: 80% auto;
		background-repeat: no-repeat;
		background-position: center;
	}

	.imagebtn:active {
		background: #167ece;
	}

	.msgbox {
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		border-top: 58px solid #fff;
		border-bottom: 54px solid #fff;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}
	.msgboxbig{
		border-top: 84px solid #fff;
	}
</style>
